/**
 * Temporary workaround for Shopify incident_28764.
 * Prevents navigation to an erroneous /en URL
 * while the current storefront language is German.
 */

document.addEventListener(
  'click',
  (event) => {
    if (document.documentElement.lang !== 'de') return;

    const link = event.target.closest?.('a[href]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    try {
      const url = new URL(href, window.location.origin);

      if (url.origin !== window.location.origin) return;
      if (!url.pathname.startsWith('/en/')) return;

      const correctedUrl =
        url.pathname.slice(3) +
        url.search +
        url.hash;

      event.preventDefault();
      window.location.href = correctedUrl;
    } catch {
      // Ignore invalid URLs.
    }
  },
  true
);